
import { Vue } from "vue-class-component";

export default class View extends Vue {}
